import { t } from '../../../locale';
import { ValidationMessage, ValidationRule } from '../useValidation.types';
import isDefined from '../utils/isDefined';

interface Config {
  message?: ValidationMessage;
}

export default function wholeNumber(config: Config = {}): ValidationRule {
  return {
    name: 'wholeNumber',
    validator(value) {
      return !isDefined(value) || (Number.isInteger(Number(value)) && Number(value) >= 0);
    },
    message: config.message || t('ll.validation.wholeNumber'),
  };
}
